import React, { Component, Fragment } from "react"
import Pagination from "react-js-pagination"
import { connect } from "react-redux"

import getRights from "../../redux/action/rights"
import { bindActionCreators } from "redux"

//Component
import Field from "../../components/Common/Field/Field"
import AlertContainer from "react-alert"
import "./printStyle.css"
import Async from "react-select"
import {
  DevelopmentServices,
  UtilityService,
  StyleServices,
  SampleServices
} from "../../services"
import Pageheader from "../../components/Page/PageHeader/PageHeader"
import Loading from "../../components/Common/Loading"
import TableRowSelect from "../../components/PrintFabricNo/TableRowSelect"
import PrintFabricPage from "../../components/PrintFabricPage"
import PrintStylePage from "../../components/PrintStylePage"

//Assets
import download from "../../assets/images/download.png"
import printer from "../../assets/images/printer.png"

//options
import { tableHeader } from "../../services/common/options"

class PrintStyleNumber extends Component {
  state = {
    moduleName: "",
    activePage: 1,
    totalItemsCount: 0,

    NumberFrom: "",
    NumberTo: "",
    SearchDateFrom: "",
    printDate:'',
    SearchDateTo: "",
    List: [],
    NumberFromList: [],
    NumberFromObj: "",
    NumberToObj: "",
    column: [],
    selectedData: [],
    isLoading: false,
    columnAll: true,
    ids: [],
    selectedNumberObj: ''
  }

  componentWillMount() {
    const moduleName = this.props.location.state.moduleName
    if (moduleName === "Style") {
      // StyleServices.SearchStyle("")
      //   .then(response => {
      //     if (response.status == 200) {
      //       let jsonData = []
      //       response.text.data.map(info =>
      //         jsonData.push({ label: info.styleNumber, value: info._id })
      //       )
      //       this.setState({ NumberFromList: jsonData, isLoading: true })
      //     }
      //   })
      //   .catch(error => {
      //     // UtilityService.errorMsg(this.msg);
      //   })

      SampleServices.getSampleReqNo("")
        .then(response => {
          if (response.status === 200) {
            this.setState({
              NumberFromList: response.text.data,
              isLoading: true
            })
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }

    this.setState({ moduleName })
  }

  componentWillReceiveProps(nextProps) {
    const moduleName = nextProps.location.state.moduleName
    // if (moduleName === "Fabric") {
    //   this.setState({ isLoading: false });
    //   DevelopmentServices.getFabricNumber("")
    //     .then(response => {
    //       if(response.status == 200){
    //         this.setState({ NumberFromList: response.text.data, isLoading: true });
    //       }
    //     })
    //     .catch(error => {
    //       UtilityService.errorMsg(this.msg, error);
    //     });
    // }

    if (moduleName === "Style") {
      this.setState({ isLoading: false })
      SampleServices.getSampleReqNo("")
        .then(response => {
          if (response.status == 200) {
            // let jsonData = []
            // response.data.map(info => {
            //   let objData = {}
            //   objData.label = info.styleNumber
            //   objData.value = info._id
            //   jsonData.push(objData)
            // })
            this.setState({
              NumberFromList: response.text.data,
              isLoading: true
            })
          }
        })
        .catch(error => {
          // UtilityService.errorMsg(this.msg);
        })
    }

    this.props.getRights(moduleName)

    this.setState({ moduleName })
  }

  getFabricNumber = value => {
    DevelopmentServices.getFabricNumber(value)
      .then(response => {
        if (response.status == 200) {
          this.setState({ NumberFromList: response.text.data, isLoading: true })
        }
        response.status == 404 &&
          this.props.getalertMessage("error", response.text.message)
        response.status == 401 &&
          this.props.getalertMessage("error", response.text.message)
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  //searchBy
  searchBy = () => {
    let { NumberTo, NumberFrom, SearchDateFrom, SearchDateTo, ids } = this.state

    if (ids && ids.length) {
      ids = ids.map(x => x.value)
      SampleServices.sampleTagByStyle(ids)
        .then(response => {
          if (response.text.data.length > 0) {
            this.setState({
              List: response.text.data,
              all: false,
              printDate:''
            })
            this.props.getalertMessage("success", "List Generated!", 3000)
          } else {
            this.props.getalertMessage(
              "error",
              "Selected Style No doesn't have any associated data to list!",
              3000
            )
          }
        })
        .catch(error => console.error(error))
    } else {
      this.props.getalertMessage("error", "Please add SR number(s)!", 3000)
    }

    // if (NumberTo !== "" && NumberFrom !== "") {
    //   let data = {
    //     filterType: this.state.moduleName === "Style" ? "styleNumber" : "",
    //     from: NumberFrom,
    //     to: NumberTo
    //   }

    //   if (this.state.moduleName === "Style") {
    //     StyleServices.searchFilterForStyleNumber(data)
    //       .then(response => {
    //         this.setState({
    //           List: response.data
    //         })
    //       })
    //       .catch(error => {})
    //   }
    // }

    // if (SearchDateFrom !== "" && SearchDateTo !== "") {
    //   let data = {
    //     filterType: "dateRange",
    //     from: SearchDateFrom,
    //     to: SearchDateTo
    //   }

    //   if (this.state.moduleName === "Style") {
    //     StyleServices.searchFilterForStyleNumber(data)
    //       .then(response => {
    //         this.setState({
    //           List: response.data
    //         })
    //       })
    //       .catch(error => {})
    //   }
    // }
  }

  getNumberList = e => {
    if (this.state.moduleName === "Style") {
      SampleServices.getSampleReqNo(e)
        .then(response => {
          if (response.status == 200) {
            this.setState({
              NumberFromList: response.text.data,
              isLoading: true
            })
          }
        })
        .catch(error => {
          // UtilityService.errorMsg(this.msg);
        })
    }
  }

  getNumberFrom = fabricNum => {
    if (fabricNum) {
      this.setState({
        NumberFrom: fabricNum.value,
        NumberFromObj: fabricNum
      })
    } else {
      this.setState({
        NumberFrom: "",
        NumberFromObj: ""
      })
      //   this.getFabricNumber("")
    }
  }

  getNumberTo = fabricNum => {
    if (fabricNum) {
      this.setState({
        NumberTo: fabricNum.value,
        NumberToObj: fabricNum
      })
    } else {
      this.setState({
        NumberTo: "",
        NumberToObj: ""
      })
      //   this.getFabricNumber("")
    }
  }

  __handleFromDateChange = (name, value) => {
    let { List, selectedData} = this.state

    if (List.length !== 0 && name === 'printDate') {
      List.map((data, index) => {
        List[index].date = value
      })
    }

    if (selectedData.length !== 0 && name === 'printDate') {
      selectedData.map((data, index) => {
        selectedData[index].date = value
      })
    }

    this.setState({
      [name]: value,
      List
    })
  }

  _handlePageChange = pageNumber => {
    this.setState({ activePage: pageNumber })
  }

  printDiv = val => {
    if (this.state.selectedData.length) {
      var divToPrint = document.getElementById(val)
      var newWin = window.open("")
      newWin.document.write(divToPrint.outerHTML)
      newWin.print()
      newWin.close()
    } else {
      this.props.getalertMessage("info", "Please select to print!")
    }
  }

  getRowData = data => {
    let selectedData = []
    if (data.all) {
      selectedData = data.rowData.map((datarowData, index) => {
        let dat = { ...datarowData }
        return dat
      })
    } else {
      selectedData = data.rowData.filter((datarowData, index) => {
        if (datarowData[`checkbox${index}`]) {
          let dat = { ...datarowData }
          return dat
        }
      })
    }

    this.setState({
      all: data.all,
      selectedData,
      column: data.column,
      columnAll: data.columnAll
    })
  }

  addNumbers = () => {
    let { ids, NumberFromObj } = { ...this.state }
    if (NumberFromObj !== "") {
      let obj = ids.find(x => x.value === NumberFromObj.value)
      if (!obj) {
        ids = [...ids, NumberFromObj]
        this.setState({ ids, selectedNumberObj: NumberFromObj.value, NumberFromObj: '' })
      } else {
        this.setState({ NumberFromObj: '' })
        this.props.getalertMessage('info', 'SR Number already added in list')
      }
    }
  }

  removeNumbers = (value) => {
    // var selected = document.getElementById("mySelectNum").value
    let { ids, NumberFromObj } = { ...this.state }
    if (value && ids && ids.length) {
      ids = ids.filter(x => x.value != value)
      this.setState({ ids })
    } else {
      this.props.getalertMessage('info', "Select SR Number")
    }
  }

  resetBy = () => {
    this.setState({ ids: [], List: [] })
  }

  render() {
    const {
      List,
      NumberFromObj,
      NumberToObj,
      NumberFromList,
      SearchDateFrom,
      printDate,
      SearchDateTo,
      isLoading,
      selectedData,
      moduleName
    } = this.state
   

    if (isLoading) {
      return (
        <Fragment>
          <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
          <div className="right-section bg-white">
            <div className="row nopadding">
              <Pageheader
                history={this.props.history}
                header={`Print Sample Tag`}
              />
              <div className="col-md-12 nopadding">
                <div className="card-container">
                  {/*MAIN-CONTENT START*/}
                  {/* FIELDS */}
                  <div class="col-md-12 nopadding">
                    <div class="col-md-12 d-flex flex-column justify-content-center align-items-center">
                      <h6 className="fw-600">{`Search by Sample Request No.`}</h6>
                      {selectedData.length > 0 && (<div className="mx-3 my-3 d-flex">
                        <div>
                          <label>Select date</label>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            inputName="printDate"
                            value={printDate}
                            onChange={this.__handleFromDateChange}
                          />
                        </div>

                        <span className="btn-green-icon mx-3">
                          <img
                            alt=""
                            className="cursor-pointer"
                            src={printer}
                            onClick={() => this.printDiv("printTable")}
                          />
                        </span>
                        {/* <span className="btn-green-icon ">
                          <img src={download} alt="" />
                        </span> */}
                      </div>)}
                      {/* FORM GROUP START */}
                      <div className="col-md-8">
                        {/* FROM FIELD START  */}
                        <div className="col-sm-4">
                          <div className="form-group">
                            <div class="custom-async-select">
                              <Async
                                name="From"
                                value={NumberFromObj}
                                onInputChange={this.getNumberList}
                                onChange={this.getNumberFrom}
                                placeholder={`Sample Request No. Start`}
                                options={NumberFromList}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <button
                            type="button"
                            className="primary"
                            onClick={() => this.addNumbers()}
                          >Add</button>
                          <button
                            type="button"
                            className="primary mx-1"
                            onClick={() => this.searchBy()}
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            className="primary"
                            onClick={() => this.resetBy()}
                          >
                            Reset
                          </button>
                        </div>
                        {this.state.ids && this.state.ids.length > 0 &&
                          <div className="col-sm-5 py-3 px-0 rounded" style={{ border: '1px solid #dee2e6' }}>
                            {/* <select
                            id="mySelectNum"
                            // onDoubleClick={() => this.props.moveToLeft()}
                            className="mySelectRight"
                            size="2"
                            style={{ display: "block" }}
                            disabled={this.state.disabled}
                            value={this.state.selectedNumberObj}
                            onChange={(e) => { this.setState({ selectedNumberObj: e.target.value }) }}
                          >{this.state.ids && this.state.ids.length &&
                            this.state.ids.map(x => <option value={x.value}>{x.label}</option>)
                            }
                          </select> */}
                            {this.state.ids.map(x => (<button
                              type="button"
                              className="primary m-1"
                            >{x.label}<sup onClick={() => this.removeNumbers(x.value)}>X</sup></button>))}

                          </div>
                        }
                      </div>
                      {/* <div className="col-md-6">
                       
                        <div className="form-group">
                          <label for="">To</label>
                          <div class="custom-async-select">
                            <Async
                              name="To"
                              value={NumberToObj}
                              onInputChange={e => this.getNumberList(e)}
                              onChange={this.getNumberTo}
                              placeholder={`${moduleName} Number End`}
                              options={NumberFromList}
                            />
                          </div>
                        </div>
                        
                      </div> */}
                    </div>
                    {/* <div class="col-md-6">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="fw-600">Search By Created Date</h6>
                        <div>
                          <span className="btn-green-icon mr-3">
                            <img
                              alt=""
                              className="cursor-pointer"
                              src={printer}
                              onClick={() => this.printDiv("printTable")}
                            />
                          </span>
                          <span className="btn-green-icon ">
                            <img src={download} alt="" />
                          </span>
                        </div>
                      </div>

                      
                      <div className="col-md-6">
                   
                        <div className="form-group">
                          <label for="">From</label>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            inputName="SearchDateFrom"
                            value={SearchDateFrom}
                            onChange={this.__handleFromDateChange}
                          />
                        </div>
                        
                      </div>
                      <div className="col-md-6">
                       
                        <div className="form-group">
                          <label for="">To</label>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            inputName="SearchDateTo"
                            value={SearchDateTo}
                            onChange={this.__handleFromDateChange}
                          />
                        </div>
                        
                      </div>
                      
                    </div> */}
                    {/* <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="primary"
                        onClick={() => this.searchBy()}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="primary"
                        onClick={() => this.resetBy()}
                      >
                        Reset
                      </button>
                    </div> */}
                  </div>
                  {/* PRINT FABRIC TABLE */}
                  {List.length > 0 && (
                    <div className="col-md-12 nopadding">
                      <TableRowSelect
                        all={this.state.all}
                        rowData={List}
                        tableHeaderData={tableHeader.stylePrintTable}
                        getRowData={this.getRowData}
                        selectedDate={printDate}
                      />
                    </div>
                  )}
                </div>
                {/*MAIN-CONTENT END */}
                {/* Print Page */}
                <div id="printTable" className="d-none">
                  {/* {this.state.moduleName === "style" &&
                    selectedData.length > 0 && ( */}
                  <PrintStylePage
                    tableHeaderData={tableHeader.stylePrintTable}
                    columnAll={this.state.columnAll}
                    column={this.state.column}
                    selectedData={selectedData}
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )
    } else {
      return <Loading />
    }
  }
}

// export default PrintFabricNumber;

const mapStateToProps = state => {
  return {
    rights: state.main.rights,
    selectedRight: state.rights.rightsInfo
  }
}
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getRights: getRights
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintStyleNumber)


// WEBPACK FOOTER //
// ./src/pages/printStyleNumber/page.js